<script setup>
import { computed } from 'vue';

// MedUp: "Каналы и филиалы" block on the contact detail card. Shows every channel the patient is
// on (contact_inboxes), the bot + source_id, opt-out status, and the branch(es) that channel serves
// (branch_inboxes). A contact has no direct branch — it's derived from the bot it joined.
// Data comes from the show endpoint's channel_bindings (see show.json.jbuilder + Contact#medup_channel_bindings).
const props = defineProps({
  contact: { type: Object, required: true },
});

const CH = {
  telegram: { icon: 'i-lucide-send', cls: 'bg-n-blue-3 text-n-blue-11', label: 'Telegram' },
  whatsapp: { icon: 'i-lucide-message-circle', cls: 'bg-n-teal-3 text-n-teal-11', label: 'WhatsApp' },
  max: { icon: 'i-lucide-messages-square', cls: 'bg-n-amber-3 text-n-amber-11', label: 'MAX' },
  sms: { icon: 'i-lucide-message-square', cls: 'bg-n-slate-3 text-n-slate-11', label: 'SMS' },
  other: { icon: 'i-lucide-radio', cls: 'bg-n-slate-3 text-n-slate-11', label: 'Канал' },
};
const chMeta = c => CH[c] || CH.other;

const bindings = computed(() => props.contact?.channelBindings || []);
</script>

<template>
  <div class="px-6 py-5 border-t border-n-weak">
    <h3 class="mb-1 text-sm font-medium text-n-slate-12">Каналы и филиалы</h3>
    <p class="mb-3 text-xs text-n-slate-10">
      Филиал определяется по каналу/боту, в котором есть пациент.
    </p>

    <div v-if="bindings.length" class="flex flex-col gap-2">
      <div
        v-for="(b, i) in bindings"
        :key="i"
        class="flex items-start gap-3 p-3 border rounded-lg border-n-weak"
      >
        <span
          :class="chMeta(b.channel).cls"
          class="flex items-center justify-center rounded-lg size-9 shrink-0"
        >
          <span :class="chMeta(b.channel).icon" class="size-4" aria-hidden="true" />
        </span>
        <div class="min-w-0">
          <div class="text-sm text-n-slate-12">
            <span class="font-medium">{{ chMeta(b.channel).label }}</span>
            <span class="text-n-slate-11">· {{ b.bot }}</span>
            <span v-if="b.unsubscribed" class="ml-1 text-xs text-n-ruby-11">отписан</span>
          </div>
          <div class="mt-0.5 text-xs text-n-slate-10">
            <span v-if="b.branches && b.branches.length" class="text-n-slate-11">
              <span class="i-lucide-building size-3 -mb-0.5" aria-hidden="true" />
              {{ b.branches.map(x => x.name).join(', ') }}
            </span>
            <span v-else>общий (без филиала)</span>
            <span v-if="b.sourceId"> · id {{ b.sourceId }}</span>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="p-3 text-xs rounded-lg text-n-slate-10 bg-n-alpha-1">
      Пациент пока не привязан ни к одному каналу. Он появится здесь, когда запустит бота
      (Telegram/MAX) или получит сообщение по WhatsApp/SMS.
    </div>
  </div>
</template>
